import { Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { SuiteShellService } from '@app/services/suite-shell.service';

/** La clase que esconde las migas de Admin solo aplica en la cara suite. */
@Directive({
  selector: '[appCaraAdmin]',
  standalone: false,
})
export class CaraAdminDirective implements OnDestroy {
  private sub: Subscription;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    shell: SuiteShellService,
  ) {
    this.sub = shell.cara$.subscribe((cara) => {
      if (cara === 'suite') this.renderer.addClass(this.el.nativeElement, 'admin-page');
      else this.renderer.removeClass(this.el.nativeElement, 'admin-page');
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
